import { ApolloError } from '@apollo/client';
import { getToken } from './token';

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace HttpClient {
  export function get(url: string, params?: { [key: string]: string }) {
    const token = getToken();
    const queryString = params ? `?${new URLSearchParams(params)}` : '';
    return fetch(`${process.env.NX_REST_API_BASE_URL}/${url}${queryString}`, {
      method: 'GET',
      headers: {
        authorization: `Bearer ${token?.accessToken}`,
      },
    });
  }

  export async function post(
    url = '',
    data: object | FormData,
    isFormData = false,
  ): Promise<Response> {
    const token = getToken();
    const headers: Record<string, string> = {
      authorization: `Bearer ${token?.accessToken}`,
    };

    if (!isFormData) {
      headers['content-type'] = 'application/json';
    }

    const response = await fetch(`${process.env.NX_REST_API_BASE_URL}/${url}`, {
      method: 'POST',
      headers,
      body: isFormData ? (data as FormData) : JSON.stringify(data),
    });

    if (!response.ok) {
      // For custom messages
      const errorJson = await response.text();
      const errorObject = JSON.parse(errorJson);
      throw new ApolloError({ errorMessage: errorObject.message });
    }

    return response;
  }
}

export default HttpClient;
